

class LineThenWord {

	constructor (tag,scope, text) {

		this.tag = tag
		this.scope = scope || document
		this.dom = this.scope.querySelector(this.tag)
		this.initialText = text
		this.text = this.initialText
		this.width = this.dom.getBoundingClientRect().width
		
		this.splited = []

		this._split()

		return this

	}

	_split () {

		this.dom.innerHTML = ""
		let words = this.initialText.split(" ")
		
		let i = 0
		let total = 0
		
		while (total < words.length) {
			
			let stack = 0
			let j = 0
			let out = false
			this.splited[i] = []

			let line = document.createElement('p')
			line.classList.add('line')
			this.dom.appendChild(line)

			while (!out && total < words.length && stack < this.width) {

				let word = document.createElement('span')
				let space = document.createElement('span')
				
				space.innerHTML = "&nbsp;"
				word.classList.add('word')
				space.classList.add('space')

				word.innerText = words[total]
				line.appendChild(word)
				line.appendChild(space)
				stack += word.getBoundingClientRect().width
				stack += space.getBoundingClientRect().width

				if (stack > this.width) {
					word.remove()
					space.remove()
					out = true

				} else {
					this.splited[i].push(word)

					j++
					total++
				}


			}

			i ++

		}


	}

	resize () {
		this.width = this.dom.getBoundingClientRect().width
		this._split()
	}

}

export default LineThenWord


// WEBPACK FOOTER //
// ./src/utils/text-spliter.js